import moment from "moment";
import React, { useState, useEffect, useMemo } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { useIntl, FormattedMessage } from "react-intl";
import { Grid } from "@material-ui/core";
import * as _ from "lodash";
import { incompleteTaskWithReason } from "../../redux/task/taskActions";
import {
    saveFollowUps,
    duplicateCheckPopup,
    clearDuplicateWorkOrders,
    noDuplicatesCheck,
    setDuplicateWorkOrders,
    resetFollowUpsState,
} from "../../redux/followUps/followUpsActions";
import { INCOMPLETE_REASON_CODES } from "../../globals/workOrderStatus";
import { useLocalizedName } from "../../globals/langHelpers";
import { getLocalizedNameWithIntl } from "../../globals/langHelpers";
import DuplicateWOWarningPopup from "../workOrderActions/duplicateTruckRollWarningPopup";
import DeleteIcon from "../common/icons/deleteIcon";
import { Button, Dialog, IconButton, TextField } from "@material-ui/core";
import DatePicker from "../common/datepicker/datePicker";
import Dropdown from "../common/dropdown/dropdown";

import "./incompleteJob.css";
import { Autocomplete } from "@material-ui/lab";
import { Caption } from "./workOrderDetails";
import FollowupActivityQuestions from "./relatedWork/FollowupActivityQuestions";
import { requestActivityQuestions } from "../../redux/activityQuestions/activityQuestionsActions";
import { DialogActions, DialogContent, DialogTitle, labels, messages, useStyles } from "./incompleteJobUtils";
import useActivityQuestions from "../activityQuestions/hooks/useActivityQuestions";
import SingleColumnContainer from "../activityQuestions/components/followupGridContainer/signleColumnContainer";
import useFollowUpsList from "../../hooks/useFollowupsList";
import useCheckDuplicateWorkOrder from "../../hooks/useCheckDuplicateWorkOrder";
import { validateFollowupWorkOrderDtos } from "../../utils/validateFollowupWorkOrderDtos";
import { generateMwaList } from "../../utils/generateMwaList";
import useIsEndToEndEnabled from "../../hooks/useIsEndToEndEnabled";

const IncompleteJob = (props) => {
    const { dueDate, showInCompleteModal, setShowInCompleteModal, reasons, subreasons, workOrderNumber, followUpReasons } = props;
    const classes = useStyles();
    const dispatch = useDispatch();
    const { activityQuestions, hasAllMandatoryQuestionsAnswered } = useActivityQuestions();
    const {
        followUpList,
        addFollowUp: addNewFollowUpToState,
        updateFollowUp,
        deleteFollowUp,
        deletedFollowUpIds,
        resetFollowups,
    } = useFollowUpsList();
    const { checkDuplicateWorkOrder } = useCheckDuplicateWorkOrder();
    const intl = useIntl();
    const { getLocalizedName } = useLocalizedName();
    const moment = require("moment-business-days");
    const reasonIdsNeedingDatePicker = [INCOMPLETE_REASON_CODES.CUSTOMER_REQUESTED_DIFF_DAY];
    const date = moment();

    const isEndToEndEnabled = useIsEndToEndEnabled(workOrderNumber);
    const [incompleteReason, setIncompleteReason] = useState(null);
    const [incompleteSubReason, setIncompleteSubReason] = useState(null);
    const [useDatePicker, setUseDatePicker] = useState(false);
    const [filteredSubReasons, setFilteredSubReasons] = useState(subreasons);
    const [additionalComments, setAdditionalComments] = useState("");
    const [newDueDate, setNewDueDate] = useState(null);
    const [filteredReasons, setFilteredReasons] = useState(followUpReasons);
    const [editingFollowUpID, setEditingFollowUpID] = useState(null);

    const isSubmitBtndisabled = useMemo(() => {
        const hasFollowupsWithQuestions = followUpList.filter((followup) => followup.hasActivityQuestions);
        const hasAllQuestionsAnswered =
            hasFollowupsWithQuestions.length > 0
                ? hasFollowupsWithQuestions.every((followup) => hasAllMandatoryQuestionsAnswered(followup.uuid))
                : true;
        return (
            !incompleteReason || (filteredSubReasons.length > 0 && !incompleteSubReason) || (useDatePicker && !newDueDate) || !hasAllQuestionsAnswered
        );
    }, [incompleteReason, filteredSubReasons, incompleteSubReason, useDatePicker, newDueDate, followUpList, hasAllMandatoryQuestionsAnswered]);

    const endToEndTypes = useMemo(
        () =>
            (process.env.REACT_APP_END_TO_END_FOLLOWUP_TYPES || "")
                .split(",")
                .map((s) => parseInt(s.trim(), 10))
                .filter((n) => !isNaN(n)),
        [process.env.REACT_APP_END_TO_END_FOLLOWUP_TYPES],
    );

    useEffect(() => {
        if (!isEndToEndEnabled) {
            setFilteredReasons(followUpReasons.filter((reason) => !endToEndTypes.includes(reason.followUpTypeID)));
        }
    }, [isEndToEndEnabled]);

    const handleFolloupReasonChange = (selectedReason, followUp) => {
        if (!selectedReason) return;
        const newFollowUp = {
            ...followUp,
            followUpTpyeId: selectedReason.followUpTypeID,
            newWorkOrderRequired: selectedReason.newWorkOrderRequired,
            workActivityID: selectedReason.workActivityID,
            isHide: false,
            dirty: true,
        };
        setEditingFollowUpID(newFollowUp.uuid);
        if (selectedReason.newWorkOrderRequired) {
            checkDuplicateWorkOrder(newFollowUp, deletedFollowUpIds, "admin_incomplete", true, { popupOpen: true }, workOrderNumber);
        }
        if (endToEndTypes.includes(Number(selectedReason.followUpTypeID)) && followUp.uuid) {
            dispatch(requestActivityQuestions(newFollowUp.workActivityID, newFollowUp.uuid));
            newFollowUp.hasActivityQuestions = true;
        } else {
            newFollowUp.hasActivityQuestions = false;
        }
        updateFollowUp(newFollowUp);
    };

    const addNewFollowup = () => {
        addNewFollowUpToState();
        props.noDuplicatesCheck(false);
    };

    const removeFollowUp = (followUp) => {
        deleteFollowUp(followUp.uuid);
    };

    const onReasonChange = (reason) => {
        setIncompleteReason(reason);
        // Clear selected subreason
        setIncompleteSubReason(null);
        var relatedSubreasons = subreasons.filter((sr) => sr.parentReasonCode === reason.id);
        setFilteredSubReasons(relatedSubreasons);
        setUseDatePicker(reasonIdsNeedingDatePicker.includes(reason.id));
    };

    const onNewDueDateChange = (dateChange) => {
        setNewDueDate(moment(dateChange).format("YYYY-MM-DD HH:mm:00"));
    };
    const removeFromDupState = () => {
        const poppedDuplicates = props.duplicateWO.filter((wo) => wo.uuid != editingFollowUpID);
        props.setDuplicateWorkOrders(poppedDuplicates);
    };

    const onModalClose = () => {
        props.clearDuplicateWorkOrders([]);
        resetFollowups();
        setShowInCompleteModal(false, false);
        props.noDuplicatesCheck(false);
    };
    const handleProceedPopup = () => {
        props.duplicateCheckPopup(false);
    };
    const handleCancelPopup = () => {
        props.duplicateCheckPopup(false);
        deleteFollowUp(editingFollowUpID);
        removeFromDupState();
        props.noDuplicatesCheck(true);
    };

    const formatDueDate = (followUp) => {
        const reason = followUpReasons.find((r) => r.followUpTypeID === followUp.followUpTpyeId);
        return reason.leadTime
            ? moment(new Date()).businessAdd(reason.leadTime).utc().format("YYYY-MM-DD HH:mm:00")
            : moment(new Date()).utc().format("YYYY-MM-DD HH:mm:00");
    };

    const submitToIncompleteState = () => {
        const validatedFollowUps = validateFollowupWorkOrderDtos(followUpList, props.duplicateWO, props.workorderData).map((followUp) => ({
            ...followUp,
            mwaList: generateMwaList(activityQuestions.questions, followUp, followUpReasons),
            dueDate: formatDueDate(followUp),
        }));
        const followupNotReady = validatedFollowUps?.find((followup) => !followup.readyForFinalSubmit);

        if (followupNotReady) {
            checkDuplicateWorkOrder(followupNotReady, deletedFollowUpIds, "admin_incomplete", true, { popupOpen: true }, workOrderNumber);
            return;
        }
        const incompleteInfo = {
            scheduledDate: date.format("YYYY-MM-DD HH:mm:ss"),
            workOrderNumber: workOrderNumber,
            reasonId: incompleteReason.id,
            subReasonId: incompleteSubReason ? incompleteSubReason.id : null,
            aditionalComments: additionalComments,
            dueDate: dueDate,
            newDueDate: newDueDate,
            userProfile: {
                sub: props.userInfo.sub,
                email_verified: props.userInfo.email_verified,
                adGroup: ["/CmisAdmin"],
                name: props.userInfo.name,
                preferred_username: props.userInfo.preferred_username,
                given_name: props.userInfo.given_name,
                family_name: props.userInfo.family_name,
                employeeNumber: props.technicianInfo.pein,
            },
        };
        // Save follow-ups if any
        const followUpInfo = validatedFollowUps?.length > 0 && {
            userProfile: incompleteInfo.userProfile,
            relatedID: workOrderNumber,
            dueDate: dueDate,
            followUpList: validatedFollowUps,
            deletedFollowUps: deletedFollowUpIds,
        };

        // incomplete job
        props.incompleteTaskWithReason(incompleteInfo, followUpInfo);

        dispatch(resetFollowUpsState());
        resetFollowups();
        setShowInCompleteModal(false, true);
    };

    return (
        <>
            <Dialog
                className="cmis-dialog"
                onClose={onModalClose}
                aria-labelledby="customized-dialog-title"
                open={showInCompleteModal}
                PaperProps={{
                    className: classes.paper,
                }}
                style={{
                    borderRadius: "10px",
                }}
                disableBackdropClick={false}>
                <DialogTitle id="customized-dialog-title" onClose={onModalClose}>
                    {intl.formatMessage(messages.incompleteJobTitle)}
                </DialogTitle>
                <DialogContent>
                    <div className={classes.currentDate}>
                        {intl.formatMessage(messages.currentDate)} {date.format("LLLL")}
                    </div>
                    <div className={classes.currentDate}>{intl.formatMessage(messages.incompleteReason)}</div>
                    <Dropdown
                        id="incomplete-reason"
                        label={intl.formatMessage(messages.reason)}
                        display={(item) => getLocalizedName({ object: item })}
                        itemValue={(item) => item.id} //ID
                        items={reasons}
                        value={incompleteReason}
                        onChange={(e) => onReasonChange(e)}
                    />
                    {useDatePicker && (
                        <DatePicker label={intl.formatMessage(messages.selectStart)} value={newDueDate} onChange={onNewDueDateChange} />
                    )}
                    <Dropdown
                        id="incomplete-sub-reason"
                        label={intl.formatMessage(messages.subReason)}
                        display={(item) => getLocalizedName({ object: item })}
                        itemValue={(item) => item.id} //ID
                        items={filteredSubReasons}
                        disabled={filteredSubReasons.length == 0}
                        value={incompleteSubReason}
                        onChange={(e) => setIncompleteSubReason(e)}
                    />
                    {process.env.REACT_APP_FEATURE_CMISR3 === "true" && (
                        <div className={classes.followups}>
                            <div className={classes.followupsheader}>{intl.formatMessage(messages.followUpIfapplicable)}</div>

                            <Grid container className={classes.root}>
                                {followUpList.map((followUp, key) => {
                                    return (
                                        <Grid className={classes.entryContainer + " " + classes.entrySpacing} item xs={12} key={followUp.uuid}>
                                            <Grid container spacing={1} alignItems="center">
                                                <Grid item spacing={1} xs={12} sm container className={classes.followupCard} id="followupCard">
                                                    <Grid item xs={12}>
                                                        <div className={classes.followupCardHeader}>
                                                            {intl.formatMessage(messages.addFollowUpTitle)} {key + 1}
                                                            {followUp.isHide ? (
                                                                <IconButton onClick={() => removeFollowUp(followUp)}>
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            ) : null}
                                                        </div>
                                                        <Caption className={classes.cardPadding}>
                                                            <FormattedMessage
                                                                id="admin.work-order-details.follow-up-list.reason-col-header"
                                                                defaultMessage="Follow-up reason"
                                                                description="Admin work order follow-up reason column header"
                                                            />
                                                        </Caption>
                                                        <Autocomplete
                                                            key={followUp.followUpTpyeId}
                                                            id="follow-up-reason-combo-box"
                                                            className={classes.cardPadding}
                                                            fullWidth
                                                            value={filteredReasons.find((r) => r.followUpTypeID === followUp.followUpTpyeId)} // This is assuming API will only return ID- will change if it returns the name too
                                                            closeText={intl.formatMessage(labels.close)}
                                                            openText={intl.formatMessage(labels.open)}
                                                            noOptionsText={intl.formatMessage(labels.noOptions)}
                                                            options={filteredReasons}
                                                            onChange={(_event, value) => handleFolloupReasonChange(value, followUp)}
                                                            getOptionLabel={(option) =>
                                                                getLocalizedNameWithIntl(intl, { object: option, value: "name" })
                                                            }
                                                            renderInput={(params) => <TextField {...params} size="small" margin="normal" />}
                                                        />
                                                    </Grid>
                                                    {followUp.hasActivityQuestions && (
                                                        <FollowupActivityQuestions
                                                            followUpUUID={followUp.uuid}
                                                            gridContainer={SingleColumnContainer}
                                                        />
                                                    )}
                                                    <Grid item xs={12}>
                                                        <Caption className={classes.cardPadding}>
                                                            <FormattedMessage
                                                                className={classes.cardPadding}
                                                                id="admin.work-order-details.follow-up-list.comment-col-header"
                                                                defaultMessage="Comment"
                                                                description="Admin work order follow-up comment column header"
                                                            />
                                                        </Caption>

                                                        <TextField
                                                            className={classes.followupAddComment}
                                                            id="followUp-comments"
                                                            value={followUp.comments}
                                                            onChange={(event) =>
                                                                updateFollowUp({ ...followUp, comments: event.target.value, dirty: true })
                                                            }
                                                            placeholder={intl.formatMessage(messages.requestComments)}
                                                            multiline
                                                            fullWidth
                                                            rows={4}
                                                            variant="outlined"
                                                            InputProps={{
                                                                inputProps: { maxLength: 300 },
                                                            }}
                                                        />
                                                        <div className={classes.characterCount}>{`${followUp?.comments?.length ?? 0}/300`}</div>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    );
                                })}
                            </Grid>
                            <Grid item xs={12} className={classes.addfollowUp}>
                                <Button secondary onClick={addNewFollowup}>
                                    <FormattedMessage
                                        id="admin.work-order-details.follow-up-list.add-follow-up-button-caption"
                                        defaultMessage="Add Follow-up +"
                                        description="Admin work order follow-up list Add follow-up button caption"
                                    />
                                </Button>
                            </Grid>
                        </div>
                    )}

                    <div className={classes.currentDate}>{intl.formatMessage(messages.additionalDetails)}</div>
                    <TextField
                        className={classes.addCommnets}
                        id="incomplete-comments"
                        value={additionalComments}
                        onChange={(e) => setAdditionalComments(e.target.value)}
                        placeholder={intl.formatMessage(messages.requestComments)}
                        multiline
                        fullWidth
                        rows={4}
                        variant="outlined"
                        InputProps={{
                            inputProps: { maxLength: 300 },
                        }}
                    />
                    <div className={classes.characterCount}>{`${additionalComments ? additionalComments.length : 0}/300`}</div>
                </DialogContent>
                <DialogActions>
                    <Button
                        key="0"
                        className={isSubmitBtndisabled ? classes.confirmDisabledButton : classes.confirmButton}
                        disabled={isSubmitBtndisabled}
                        onClick={() => submitToIncompleteState()}>
                        <FormattedMessage
                            id="incomplete-dialog-dialog.submit-button"
                            defaultMessage="Submit"
                            description="Incomplete a Job with Reason"
                        />
                    </Button>
                </DialogActions>
            </Dialog>
            {props.isOpen ? (
                <DuplicateWOWarningPopup
                    open={props.isOpen}
                    setOpen={() => duplicateCheckPopup(false)}
                    handleClose={handleProceedPopup}
                    handleCancel={handleCancelPopup}
                    followUpsResponse={props.followUpsResponse}
                    keycloak={props.keycloak}
                />
            ) : null}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        followUpReasons: state.followUps.followUpReasons ? state.followUps.followUpReasons : [],
        reasons: state.reasons.partialReasons.has("Incomplete")
            ? state.reasons.partialReasons.get("Incomplete").filter((reason) => !reason.parentReasonCode)
            : [],
        subreasons: state.reasons.partialReasons.has("Incomplete")
            ? state.reasons.partialReasons.get("Incomplete").filter((reason) => reason.parentReasonCode)
            : [],
        userProfile: state.login.userProfile,
        userInfo: state.login.userInfo,
        technicianInfo: state.login.technicianInfo,
        workorderData: state.tasks.workorderData.workorderData,
        workOrderDatas: state.tasks.tasks,
        followUpsResponse: state.followUps.followUpsResponse,
        isOpen: state.followUps.isOpen,
        duplicateWO: state.followUps.duplicateWO,
        noDuplicates: state.followUps.noDuplicates,
    };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            incompleteTaskWithReason,
            saveFollowUps,
            duplicateCheckPopup,
            clearDuplicateWorkOrders,
            noDuplicatesCheck,
            setDuplicateWorkOrders,
        },
        dispatch,
    );

export default connect(mapStateToProps, mapDispatchToProps)(IncompleteJob);
